import Avatar from "components/BaseWidgets/Avatar";
import profilePic from "assets/images/png/avatar.png";
import Button from "components/BaseWidgets/button";
import { ConnectAudioIncoming, PostComments } from "assets/icons";
import Tag from "components/BaseWidgets/tag";
import "./style.scss";
import { useMessageRequestStatus } from "hooks/api/useMessageRequestStatus";
import {
  doc,
  updateDoc,
  getDocs,
  collection,
  query,
  where,
  setDoc,
} from "firebase/firestore";
import { db } from "../../../../../../firebase/firebaseChat";
import { getUser } from "utils/storage";
import { useCallRequestStatus } from "hooks/api/useCallRequestStatus";
function RequestCard({ name, status, request, isActive, requestType }) {
  // console.log(request);
  const id = request?.id;
  const aec_id = request?.aec_id;
  // const { , status, id } = request;
  // status: 1=SENT, 2=ACCEPTED, 3=DECLINED, 4=CANCELLED

  const updateAcceptedInFirebase = async (request, value) => {
    try {
      const currentUser = getUser()?.aec_id;
      const otherUser = request?.aec_id;

      if (!currentUser || !otherUser) return;

      const sorted = [currentUser, otherUser].sort();
      const generatedChatId = `${sorted[0]}_${sorted[1]}`;

      const chatId = generatedChatId;

      const q = query(collection(db, "chats"), where("chatId", "==", chatId));
      const snapshot = await getDocs(q);

      // 🌟 COMMON FIELDS TO ALWAYS WRITE
      const baseChatData = {
        chatId,
        users: [currentUser, otherUser],

        req_accepted: value,

        lastMessageSender: null,
        lastMessageType: null,
        lastMessageTime: null,

        typingStatus: {
          [currentUser]: false,
          [otherUser]: false,
        },

        unreadMessageCount: {
          [currentUser]: 0,
          [otherUser]: 0,
        },

        lastSeen: {
          [currentUser]: new Date(),
          [otherUser]: null,
        },

        onlineStatus: {
          [currentUser]: false,
          [otherUser]: false,
        },

        participants: {
          [currentUser]: {
            name: getUser()?.full_name,
            image: getUser()?.profile_image ?? "",
          },
          [otherUser]: {
            name: request?.user_name ?? request?.name ?? "New User",
            image: request?.profile_image ?? "",
          },
        },

        userSettings: {
          [currentUser]: {
            muted: false,
            pinned: false,
            favorite: false,
            blocked: false,
          },
          [otherUser]: {
            muted: false,
            pinned: false,
            favorite: false,
            blocked: false,
          },
        },
      };

      if (snapshot.empty) {
        // 🆕 CREATE NEW CHAT
        await setDoc(doc(collection(db, "chats")), baseChatData);
        // console.log("🟢 Chat CREATED with request accepted:", chatId);
      } else {
        // ✏️ UPDATE EXISTING
        const chatDoc = snapshot.docs[0];
        const chatRef = doc(db, "chats", chatDoc.id);

        await updateDoc(chatRef, baseChatData);
        // console.log("🟡 Chat UPDATED with request accepted:", chatId);
      }

      // 📌 Debug info
      const updatedSnapshot = await getDocs(q);
      // console.log("🟩 Updated Chat Data:", updatedSnapshot.docs[0]?.data());
    } catch (error) {
      console.error("🔥 Firestore update error:", error);
    }
  };

  const { mutate: updateMessageStatus } = useMessageRequestStatus({
    onSuccess: async (_, variables) => {
      // console.log(variables, "variables");

      if (!variables) return; // prevent crash
      if (variables.status === 2) {
        await updateAcceptedInFirebase(request, true); // accepted
      } else if (variables.status === 3 || variables.status === 4) {
        await updateAcceptedInFirebase(request, false); // declined/cancelled
      }
    },
  });

  const { mutate: updateCallStatus } = useCallRequestStatus({
    onSuccess: async (_, variables) => {
      if (!variables) return;

      if (variables.status === 2) {
        await updateAcceptedInFirebase(request, true);
      } else if (variables.status === 3) {
        await updateAcceptedInFirebase(request, false);
      }
    },
  });

  const handleStatusUpdate = (status) => {
    // console.log(request.request_type, "");

    if (requestType === 2) {
      updateCallStatus({
        //call
        to_user: request.aec_id,
        status,
      });
    } else {
      updateMessageStatus({
        //message
        aec_id: request.aec_id,
        status,
      });
    }
  };

  const renderStatus = () => {
    switch (status) {
      case 1:
        return (
          <div className="flex gap-2">
            <Button
              className="accept-btn"
              onClick={() => handleStatusUpdate(2)}
              height={30}
            >
              Accept
            </Button>
            <Button
              variant="secondary"
              onClick={() => handleStatusUpdate(3)}
              height={30}
            >
              Reject
            </Button>
          </div>
        );

      case 2:
        return <Tag variant="success">Accepted</Tag>;

      case 3:
        return <Tag variant="rejected">Declined</Tag>;

      case 4:
        return <Tag variant="rejected">Cancelled</Tag>;

      default:
        return null;
    }
  };

  // console.log(request, "request");

  return (
    <div className={`request-card items-center ${isActive ? "active" : ""}`}>
      <div className="flex items-center gap-3">
        <Avatar url={request.profile_image} size={48} />
        <div className="flex flex-col gap-1">
          <span className="font-body-md leading-3">{name}</span>
          <div className="flex items-center gap-2">
            {/* {status === "Call" ? (
              <ConnectAudioIncoming />
            ) : ( */}
            <PostComments height={20} width={20} />
            {/* )} */}
            <p className="grey-shade1 font-body-md fw-500 leading-2">
              {status}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-end gap-2">{renderStatus()}</div>
    </div>
  );
}

export default RequestCard;
